import { Button, Input } from "@simplicity/ui";
import { Globe, Plus, Trash2 } from "lucide-react";
import { useState } from "react";

import { SectionHeader } from "./SectionHeader";

export function DomainsSection({
  domains,
  domainsLoading,
  onAddDomain,
  onRemoveDomain,
}: {
  domains: { id: string; domain: string }[];
  domainsLoading: boolean;
  onAddDomain: (domain: string) => void;
  onRemoveDomain: (id: string) => void;
}) {
  const [collapsed, setCollapsed] = useState(false);
  const [newDomain, setNewDomain] = useState("");

  const handleAdd = () => {
    const domain = newDomain.trim().toLowerCase();
    if (!domain) return;
    onAddDomain(domain);
    setNewDomain("");
  };

  return (
    <section className="mb-10">
      <SectionHeader
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        icon={<Globe className="h-5 w-5" />}
        title="Pre-Permissioned Domains"
      />
      {!collapsed && (
        <>
          <p className="text-sm text-muted-foreground mb-4">
            Users with a Google account from these domains will automatically get viewer access on
            their first sign-in.
          </p>
          <div className="flex gap-2 mb-4">
            <Input
              size="sm"
              value={newDomain}
              onChange={(e) => setNewDomain(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleAdd();
                }
              }}
              placeholder="example.com"
              className="flex-1"
            />
            <Button size="sm" onClick={handleAdd} disabled={!newDomain.trim()}>
              <Plus className="h-4 w-4" /> Add
            </Button>
          </div>
          {domainsLoading ? (
            <p className="text-sm text-muted-foreground">Loading domains...</p>
          ) : domains.length === 0 ? (
            <p className="text-sm text-muted-foreground">No domains configured yet.</p>
          ) : (
            <ul className="border border-border rounded divide-y divide-border">
              {domains.map((d) => (
                <li key={d.id} className="flex items-center justify-between px-4 py-3 text-sm">
                  <span className="font-medium">{d.domain}</span>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="h-auto w-auto p-1 text-muted-foreground hover:text-destructive"
                    onClick={() => onRemoveDomain(d.id)}
                    aria-label="Remove domain"
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </section>
  );
}
